import {
  ACTIVITY_FIELD,
  getDeadlineDate,
  isAllowedExtension,
  isCostValueValid,
} from "./addexternal.utils";

export const validateActivity = ({
  options = {},
  activityData,
  activity,
  fromEducationHistory,
  itemMetadataFields,
  itemMetadataValuesById,
  allowedExtensions,
  languageContext,
}) => {
  const {
    requireStartEndForApproval = false,
    requireTitle = false,
    requireExpireDate = !fromEducationHistory,
    checkStartBeforeExpire = false,
    checkFileExtension = false,
  } = options;

  const activityFieldErrors = {};
  const itemMetadataErrorsById = {};
  const deadlineDate = getDeadlineDate(activityData, activity);

  if (requireTitle && !activityData.title) {
    activityFieldErrors[ACTIVITY_FIELD.TITLE] =
      languageContext("errEnterTitle");
  }

  if (requireStartEndForApproval && !activityData.startDate) {
    activityFieldErrors[ACTIVITY_FIELD.START_DATE] =
      languageContext("enterStartdate");
  }

  if (requireStartEndForApproval && !activityData.endDate) {
    activityFieldErrors[ACTIVITY_FIELD.END_DATE] =
      languageContext("enterEnddate");
  }

  if (requireExpireDate && !deadlineDate) {
    activityFieldErrors[ACTIVITY_FIELD.EXPIRE_DATE] =
      languageContext("enterExpiredate");
  }

  if (
    activityData.startDate &&
    activityData.endDate &&
    activityData.startDate > activityData.endDate
  ) {
    activityFieldErrors[ACTIVITY_FIELD.DATE_RANGE] =
      languageContext("badduration");
  }

  if (
    checkStartBeforeExpire &&
    activityData.startDate &&
    activityData.expireDate &&
    activityData.startDate > activityData.expireDate
  ) {
    activityFieldErrors[ACTIVITY_FIELD.START_EXPIRE_ORDER] =
      languageContext("badexpiredate");
  }

  if (
    checkFileExtension &&
    activityData.files &&
    !isAllowedExtension(activityData.files[0].name, allowedExtensions)
  ) {
    activityFieldErrors[ACTIVITY_FIELD.FILE_EXTENSION] =
      languageContext("extnotallowed");
  }

  if (!isCostValueValid(activityData.cost)) {
    activityFieldErrors[ACTIVITY_FIELD.COST] = languageContext("invalidcost");
  }

  if (itemMetadataFields.length > 0) {
    itemMetadataFields.forEach((field) => {
      if (!field.obligatory) {
        return;
      }

      const value = itemMetadataValuesById[field.id];
      if (
        value === undefined ||
        value === null ||
        String(value).trim() === ""
      ) {
        const fieldTitle = field.name ? languageContext(field.name) : "";
        itemMetadataErrorsById[field.id] = [
          languageContext("infoRequiredField"),
          fieldTitle,
        ]
          .filter(Boolean)
          .join(" ");
      }
    });
  }

  return { activityFieldErrors, itemMetadataErrorsById };
};
